import { approvalProcessStatusDropdownOption } from "presentation/constant/DropDownOptions/StaticDropdownOptions";
import { StandardProposalConstant } from "presentation/constant/StandardProposal/StandardProposalConstant";
import { useStandardProposalVM } from "presentation/hook/StandardProposal/useStandardProposalVM";
import { useStandardProposalTracked } from "presentation/store/StandardProposal/StandardProposalProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import DateRangePickerComponent from "presentation/view/components/DateRangePickerComponent";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { memo, useMemo } from "react";
import { FieldType, IFieldValue } from "veronica-ui-component/dist/component/core";

const StandardProposalSearchForm = () => {
    const STANDARD_PROPOSAL_CONSTANT = StandardProposalConstant.Search;
    const [standardProposalState] = useStandardProposalTracked();
    const standardProposalVM = useStandardProposalVM();
    const searchCriteria = standardProposalState.searchCriteria;


    const memoProposalNo = useMemo(() =>
        <div className='flex-row-item' style={{ width: "180px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria.proposalNo || ''}
                fieldValue={searchCriteria.proposalNo}
                fieldLabel={STANDARD_PROPOSAL_CONSTANT.PROPOSAL_NO}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'proposalNo'}
                maxLength={7}
                isTextFieldCapitalize={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    standardProposalVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [STANDARD_PROPOSAL_CONSTANT.PROPOSAL_NO, searchCriteria.proposalNo, standardProposalVM])


    const memoCompanyCode = useMemo(() =>
        <div className='flex-row-item' style={{ width: "180px" }}>

            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria?.companyCodeList?.join(',')}
                fieldValue={searchCriteria?.companyCodeList}
                fieldLabel={STANDARD_PROPOSAL_CONSTANT.COMPANY_CODE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'companyCodeList'}
                maxLength={60}
                isMultipleDropDown={true}
                options={standardProposalState.dynamicOptions.companyCodeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    standardProposalVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [STANDARD_PROPOSAL_CONSTANT.COMPANY_CODE, searchCriteria.companyCodeList, standardProposalState.dynamicOptions.companyCodeDropdownOptions, standardProposalVM])

    const memoOperatingTml = useMemo(() =>
        <div className='flex-row-item' style={{ width: "180px" }}>

            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria?.operatingTmlList?.join(',')}
                fieldValue={searchCriteria?.operatingTmlList}
                fieldLabel={STANDARD_PROPOSAL_CONSTANT.OPERATING_TML}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'operatingTmlList'}
                maxLength={60}
                isMultipleDropDown={true}
                options={standardProposalState.dynamicOptions.operatingTmlDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    standardProposalVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [STANDARD_PROPOSAL_CONSTANT.OPERATING_TML, searchCriteria.operatingTmlList, standardProposalState.dynamicOptions.operatingTmlDropdownOptions, standardProposalVM])

    const memoStatus = useMemo(() =>
        <div className='flex-row-item' style={{ width: "180px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria?.statusList?.join(',')}
                fieldValue={searchCriteria?.statusList}
                fieldLabel={STANDARD_PROPOSAL_CONSTANT.STATUS}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'statusList'}
                maxLength={60}
                isMultipleDropDown={true}
                options={approvalProcessStatusDropdownOption}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    standardProposalVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [STANDARD_PROPOSAL_CONSTANT.STATUS, searchCriteria.statusList, standardProposalVM])


    const memoEffectiveDateFromTo = useMemo(() =>
        <div className='im-flex-row-item'>
            <DateRangePickerComponent
                label={STANDARD_PROPOSAL_CONSTANT.EFFECTIVE_DATE_RANGE}
                width='390px'
                fieldNames={{ startField: "effectiveDateFrom", endField: "effectiveDateTo" }}
                dateRange={{ startDate: searchCriteria.effectiveDateFrom, endDate: searchCriteria.effectiveDateTo }}
                onDatesChange={standardProposalVM.onDateRangeChange}
            />
        </div>
        , [STANDARD_PROPOSAL_CONSTANT.EFFECTIVE_DATE_RANGE, searchCriteria.effectiveDateFrom, searchCriteria.effectiveDateTo, standardProposalVM.onDateRangeChange])

    return <>

        <CriteriaItemContainer>
            {standardProposalState.enabledSearchCriteria.companyCode ? memoCompanyCode : null}
            {standardProposalState.enabledSearchCriteria.operatingTml ? memoOperatingTml : null}
        </CriteriaItemContainer>

        <CriteriaItemContainer>
            {standardProposalState.enabledSearchCriteria.proposalNo ? memoProposalNo : null}
            {standardProposalState.enabledSearchCriteria.status ? memoStatus : null}
        </CriteriaItemContainer>

        <CriteriaItemContainer>
            {standardProposalState.enabledSearchCriteria.effectiveDateRange ? memoEffectiveDateFromTo : null}
        </CriteriaItemContainer>

    </>;
}
export default memo(StandardProposalSearchForm);